<template src="./App.html"></template>
<style src="./App.css"></style>

<script>
import Inventory from '@/components/Inventory/Inventory.vue'

export default {
  name: 'App',
  components: {
    'fta-inventory': Inventory
  }
}
</script>
